import { Injectable } from '@angular/core';
import {AutenticacionService} from './autenticacion.service';
import {HttpClient} from '@angular/common/http';
import {AppSettings} from '../../proyect.conf';
import {Observable} from 'rxjs';
import {SolicitudInversion} from '../_models/solicitud-inversion';
import {ExcelAvance} from '../_models/excel-avance';

@Injectable({
  providedIn: 'root'
})
export class SolicitudInversionService {
  private rutaServicio: string = AppSettings.rutServiciosAUTOGES + "/api/solicitudesCdts";
  private rutaServicio2: string = AppSettings.rutServiciosAUTOGES + "/api/solicitudCdts";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService,
  ) {}

  getCountPendingStatus(): Observable<number> {
    return this.httpClient.get<number>(`${this.rutaServicio}/countPendienteSolicitudCdt`);
  }

  getPendingStatus(data: any): Observable<{totalPages: number; totalElements: number, content: SolicitudInversion[]}> {
    return this.httpClient.post<{totalPages: number; totalElements: number, content: SolicitudInversion[]}>(`${this.rutaServicio}/solicitudesPendienteCdt`, data);
  }

  pendingChangeStatus(data: any): Observable<any> {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post<any>(`${this.rutaServicio}/cambioEstado`, data);
  }

  pendingChangeStatusAll(): Observable<ExcelAvance> {
    return this.httpClient.get<ExcelAvance>(`${this.rutaServicio}/lanzarAprobacion/usuario/${this.autServicio.obtenerIdUsuarioLogueado()}`);
  }

}
